import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/preview/zipRenderer/nodes/styles.scss';export default {
  "parentNode": "_parentNode_14b89_1",
  "backArrow": "_backArrow_14b89_11",
  "name": "_name_14b89_17",
  "list": "_list_14b89_23",
  "node": "_node_14b89_28"
};